// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";

export {
    unsafePerformEffect
} from "./foreign.js";
//# sourceMappingURL=index.js.map
